module.exports = __webpack_public_path__ + "static/media/no_image.37919d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/no_image.jpg
// module id = 276
// module chunks = 0